import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["trigger", "other"];

  connect() {
    this.form = this.element.closest("form");
    if (!this.form) {
      console.warn("Couldn't find form to interact with");
      return;
    }

    this.check();
    this.boundChange = () => this.check();
    this.form.addEventListener("change", this.boundChange);
  }

  disconnect() {
    if (this.form) {
      this.form.removeEventListener("change", this.boundChange);
    }
  }

  check() {
    if (this.triggerTarget.checked) {
      this.otherTarget.classList.remove("disabled");
      this.inputList().forEach((e) => {
        e.removeAttribute("disabled");
      });
    } else {
      this.otherTarget.classList.add("disabled");
      this.inputList().forEach((e) => {
        if (e.getAttribute("type") == "checkbox") {
          e.checked = false;
        } else if (e.getAttribute("data-default")) {
          e.click();
        }
        e.setAttribute("disabled", true);
      });
    }
  }

  inputList() {
    return Array.prototype.slice.call(
      this.otherTarget.getElementsByTagName("input"),
    );
  }
}
